export default __webpack_public_path__ + "content/media/31.6c3aedeb.jpg";